import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import InputMask from "react-input-mask";

import { getExtraProductDetailsByCode, getMainProductDetails, parseBooleanValue } from "_helpers";
import FormPDF from "components/OrderDetails/ProductDetails/FormPDF";

import StatusEdit from "../../Status/Edit";
import { LLC_INCORPORATION_CODES } from "variables/Variables";

function FormAnnualComplianceReport({
  parentOrderDetails,
  orderDetails,
  selectedProduct,
  onParentChange,
  onChange,
  onSelectedProduct,
}) {
  const productDetails = orderDetails?.products[selectedProduct];
  const processingResult = productDetails?.processingResult;
  const { mainOrderDetails, mainProductIndex, mainProductDetails, isParent } = getMainProductDetails(
    orderDetails,
    parentOrderDetails
  );
  const { extraProductDetails } = getExtraProductDetailsByCode(
    orderDetails,
    parentOrderDetails,
    LLC_INCORPORATION_CODES
  );
  const llcState = extraProductDetails?.organizedState;

  const isEinAcrPre = productDetails?.code?.code === "EIN_AnnualComplianceReport_Pre";

  const handleProductChange = ({ target: { name, value } }) =>
    onChange({
      ...orderDetails,
      products: orderDetails.products.map((product, idx) =>
        idx === selectedProduct ? { ...product, [name]: value } : product
      ),
    });

  const handleMainProductChange = ({ target: { name, value } }) => {
    const exFields = {};

    if (name === "ssn") {
      exFields.owner = {
        ...mainProductDetails?.owner,
        ssn: value || null,
      };
    }

    const onEvent = isParent ? onParentChange : onChange;

    onEvent({
      ...mainOrderDetails,
      products: mainOrderDetails?.products.map((product, idx) =>
        idx === mainProductIndex ? { ...product, ...exFields } : product
      ),
    });
  };

  const handleMarylandQuestionsChange = ({ target: { name, value } }) => {
    let newData = value;

    if (value === "yes") {
      newData = true;
    }

    if (value === "no") {
      newData = false;
    }

    if (value === "") {
      newData = null;
    }

    const marylandAnnualQuestions = { ...productDetails.marylandAnnualQuestions, [name]: newData };

    handleProductChange({ target: { name: "marylandAnnualQuestions", value: marylandAnnualQuestions } });
  };

  return (
    <div className="form-border">
      <h4 className="m-0 font-weight-bold mb-2">Annual Compliance Report</h4>
      <StatusEdit
        orderDetails={orderDetails}
        selectedProduct={selectedProduct}
        onChange={onChange}
        onSelectedProduct={onSelectedProduct}
      />

      {productDetails.webFileNumber !== undefined && (
        <Form.Group as={Row}>
          <Form.Label column sm={5}>
            Webfile Number:
          </Form.Label>
          <Col sm={7}>
            <Form.Control
              // required={productDetails?.state === "TX" && processingResult?.status !== "MissingWebFile"}
              size="sm"
              type="text"
              name="webFileNumber"
              pattern="^[a-zA-Z0-9!@#%&'_=;:,<> \+\*\^\|\{\}\.\?\$\(\)\[\]\-\/\\]+$"
              value={productDetails?.webFileNumber || ""}
              onChange={handleProductChange}
            />
          </Col>
        </Form.Group>
      )}

      {mainProductDetails && (
        <>
          <hr />
          <Form.Group as={Row}>
            <Form.Label column sm={5}>
              Social Security Number:
            </Form.Label>
            <Col sm={7}>
              <InputMask
                className="form-control form-control-sm"
                mask="999-99-9999"
                maskChar=" "
                name="ssn"
                placeholder="999-99-9999"
                pattern="^\d{3}-\d{2}-\d{4}$"
                value={mainProductDetails?.owner?.ssn || ""}
                onChange={handleMainProductChange}
                onInvalid={() => handleAddError("Social Security Number")}
              />
            </Col>
          </Form.Group>
        </>
      )}

      <FormPDF productDetails={productDetails} />

      {isEinAcrPre && llcState === "MD" && (
        <>
          <hr />
          <h6 className="font-weight-bold">Maryland Annual Report Questions</h6>

          <Form.Group as={Row}>
            <Form.Label column sm={5}>
              Does business own, lease, or use personal property, located in Maryland with a total original cost of
              $20,000 or more?
            </Form.Label>
            <Col sm={7}>
              <Form.Control
                as="select"
                name="usePersonalProperty"
                value={parseBooleanValue(productDetails?.marylandAnnualQuestions?.usePersonalProperty)}
                onChange={handleMarylandQuestionsChange}
              >
                <option value="">Please select</option>
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </Form.Control>
            </Col>
          </Form.Group>

          <Form.Group as={Row}>
            <Form.Label column sm={5}>
              Did the business have more than one physical location in Maryland for the year being filed?
            </Form.Label>
            <Col sm={7}>
              <Form.Control
                as="select"
                name="moreThanOnePhysicalLocation"
                value={parseBooleanValue(productDetails?.marylandAnnualQuestions?.moreThanOnePhysicalLocation)}
                onChange={handleMarylandQuestionsChange}
              >
                <option value="">Please select</option>
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </Form.Control>
            </Col>
          </Form.Group>

          <Form.Group as={Row}>
            <Form.Label column sm={5}>
              Has the location of the property changed from last year’s return?
            </Form.Label>
            <Col sm={7}>
              <Form.Control
                as="select"
                name="locationHasChanged"
                value={parseBooleanValue(productDetails?.marylandAnnualQuestions?.locationHasChanged)}
                onChange={handleMarylandQuestionsChange}
              >
                <option value="">Please select</option>
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </Form.Control>
            </Col>
          </Form.Group>

          <Form.Group as={Row}>
            <Form.Label column sm={5}>
              Is the property located inside the limits of an incorporated town?
            </Form.Label>
            <Col sm={7}>
              <Form.Control
                as="select"
                name="locatedInsideIncorporatedTown"
                value={parseBooleanValue(productDetails?.marylandAnnualQuestions?.locatedInsideIncorporatedTown)}
                onChange={handleMarylandQuestionsChange}
              >
                <option value="">Please select</option>
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </Form.Control>
            </Col>
          </Form.Group>
        </>
      )}
    </div>
  );
}

export default FormAnnualComplianceReport;
